<template>
  <div class="column content-box">
    <div class="row">
      <div class="empty-wrapper">
        <woot-loading-state
          v-if="uiFlags.isFetching"
          :message="$t('INTEGRATION_APPS.FETCHING')"
        />
      </div>

      <div class="small-12 columns integrations-wrap">
        <div class="row integrations">
          <div
            v-for="item in filteredIntegrations"
            :key="item.id"
            class="small-12 columns integration"
          >
            <integration-item
              :integration-id="item.id"
              :integration-logo="item.logo"
              :integration-name="item.name"
              :integration-description="item.description"
              :integration-enabled="item.hooks.length"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import IntegrationItem from './IntegrationItem';
import agentMixin from 'dashboard/mixins/agentMixin';
import adminMixin from '../../../../mixins/isAdmin';

export default {
  components: {
    IntegrationItem,
  },
  mixins: [agentMixin, adminMixin],
  computed: {
    ...mapGetters({
      uiFlags: 'labels/getUIFlags',
      integrationsList: 'integrations/getAppIntegrations',
      getAccount: 'accounts/getAccount',
      currentAccountId: 'getCurrentAccountId',
    }),

    account() {
      return this.getAccount(this.currentAccountId);
    },
    permissionToViewCatalog() {
      return this.isPermissionManagerCatalogProduct && !this.isAdmin;
    },
    filteredIntegrations() {
      const withoutWise = this.integrationsList.filter(
        item => item.id !== 'wise'
      );
      const list = this.permissionToViewCatalog
        ? withoutWise.filter(item => item.id === 'catalog')
        : withoutWise;

      return list.filter(item => {
        if (item.id === 'update_avatar') {
          return !!this.account?.enable_update_avatar;
        }
        return true;
      });
    },
  },
  mounted() {
    this.$store.dispatch('integrations/get');
  },
};
</script>

<style scoped lang="scss">
@import '~dashboard/assets/scss/variables';
.empty-wrapper {
  margin: var(--space-zero) auto;
}
</style>
